// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"b912c200c0d202a5ea76","293":"57caa817933e97c2c273"}[chunkId] + ".js";
};